import { AlertTriggerControlsInputsInterface } from "@fds/wm-typescript-poc-waap-library";
import {
  AlertTriggerControlsStoreModuleFactory,
  IdNotationType,
} from "@fds/wm-typescript-poc-waap-stores-mdg2";

export class EgbAlertTriggerControlsStoreModuleFactory extends AlertTriggerControlsStoreModuleFactory {
  protected async updateAlertingPricesBasicTriggerCreate(
    id: string,
    payload: AlertTriggerControlsInputsInterface<IdNotationType>
  ): Promise<boolean> {
    try {
      const request = this.constructCreateTriggerRequest(
        id,
        payload.limit.above,
        payload.limit.below
      );

      return this.getEndpoints().alertingPricesBasicTriggerCreate.updateState(
        request as any
      );
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }

  protected constructCreateTriggerRequest(
    id: string,
    upperLimit: number | null,
    lowerLimit: number | null
  ): EgbAlertingPricesBasicTriggerCreateRequest {
    return {
      data: {
        listing: {
          identifier: {
            value: id,
            type: "idNotation",
          },
        },
        deleteOnceTriggered: true,
        price: {
          type: "trade",
          quality: "BST",
        },
        range: {
          ...(lowerLimit && { lowerLimit }),
          ...(upperLimit && { upperLimit }),
        },
        notification: {
          channel: {
            ids: [300],
          },
        },
      },
    };
  }
}

interface EgbAlertingPricesBasicTriggerCreateRequest {
  data: {
    listing: {
      identifier: {
        value: string;
        type: string;
      };
    };
    deleteOnceTriggered?: boolean;
    price?: {
      type?: "ask" | "bid" | "trade";
      quality?: "BST" | "DLY" | "EOD" | "RLT";
    };
    range: {
      lowerLimit?: number;
      upperLimit?: number;
    };
    notification?: {
      channel?: {
        ids?: number[];
      };
    };
  };
}
